/* eslint-disable no-console */
export const getSearchParams = (url: string) => {
  console.log('url in getSearchParams: ', url);
  const queryString = url.split('?')[1];
  console.log('url in queryString: ', queryString);
  if (!queryString) return {};

  const searchParams = new URLSearchParams(queryString);
  console.log('url in searchParams: ', searchParams);
  const params: Record<string, string> = {};

  for (const [key, value] of searchParams.entries()) {
    console.log('url in searchParams: ', searchParams);
    params[key] = value;
  }

  return params;
};
